/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { Arrow } from '../Icons/iconList';
import './_Button.scss';

export function CTAButton({
  ctaText,
  className,
  Icon = Arrow, // <--- DEFAULT ICON HERE
  iconColor,
  showIcon = true,
  ...props
}) {
  return (
    <button
      type='button'
      className={`heroCTA ${className}`}
      {...props}
    >
      <p className='proxima-nova-bold text-white'>{ctaText}</p>
      {showIcon && Icon ? <Icon color={iconColor} /> : null}
    </button>
  );
}

CTAButton.propTypes = {
  ctaText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  Icon: PropTypes.func, // <--- still supports custom icons
  iconColor: PropTypes.string,
  showIcon: PropTypes.bool,
};
